import { useParams } from "react-router-dom";

// Import reusable components.
import CustomerPageForm from "./components/CustomerPageForm";

export default function CustomerDetails () {
    const { id } = useParams();
    const isEditMode = id !== "new";
    
    return (
        <div className="flex flex-col">
            <CustomerPageForm customerId={isEditMode ? id : null} />
        </div>
    );
};
